import ServiceDetailPage from "@/components/ServiceDetailPage";

const Certification = () => <ServiceDetailPage pageKey="certification" />;

export default Certification;
